// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 902 ? "c62fb0c9" : chunkId) + "." + {"771":"8da4dd62e33a2d70","902":"960e0c884c8c4c56"}[chunkId] + ".js";
};